// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  // apiKey: "AIzaSyA9SKYKFlUWy-UYTCeVV8zcoI6tXy0oz48",
  // authDomain: "event-74af9.firebaseapp.com",
  // projectId: "event-74af9",
  // storageBucket: "event-74af9.firebasestorage.app",
  // messagingSenderId: "479465511488",
  // appId: "1:479465511488:web:3d985d34935d39a8cadda5",
  // measurementId: "G-6ZMV5QVFNB"

  apiKey: "AIzaSyCgoH0W3Njl4icot8LuzAoyRoK4osr01TU",
  authDomain: "edtravel-f1ec8.firebaseapp.com",
  projectId: "edtravel-f1ec8",
  storageBucket: "edtravel-f1ec8.firebasestorage.app",
  messagingSenderId: "382877855468",
  appId: "1:382877855468:web:ff3099d38d838206deffc9",
  measurementId: "G-FQE47387P5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };
